import { useContext } from 'react';
import { OrganizationContext, OrganizationContextType } from '../context/OrganizationContext';

/**
 * Hook to access the OrganizationContext
 * Must be used within an OrganizationProvider
 */
export const useOrganization = (): OrganizationContextType => {
  const context = useContext(OrganizationContext);

  if (!context) {
    throw new Error('useOrganization must be used within OrganizationProvider');
  }

  return context;
};
